import { cn } from '#/shared/lib/utils'

interface DateCellProps {
  date: string
  time?: string
  subtitle?: string
  size?: 'default' | 'sm'
}

export function DateCell({
  date,
  time,
  subtitle,
  size = 'default',
}: DateCellProps) {
  return (
    <div className="flex flex-col items-start">
      <div className="flex h-7 items-center">
        <span
          className={cn('text-gray-900', size === 'sm' ? 'text-sm' : 'text-md')}
        >
          {date}
        </span>
      </div>
      {time && (
        <div className="flex h-7 items-center">
          <span className="text-sm text-gray-500">{time}</span>
        </div>
      )}
      {subtitle && (
        <div className="flex h-7 items-center">
          <span className="text-sm text-gray-900">{subtitle}</span>
        </div>
      )}
    </div>
  )
}
